<template>
  <div class="p-contentplans-writing-ai-phase">
    <Advice v-if="isLoading" img="pencil" priority="low-gray">
      <p>タイトル案を考えています<span class="c-loading-dots"></span></p>
    </Advice>
    <template v-else>
      <Advice img="pencil" priority="low-gray">
        <p v-if="isError">
          調査したキーワードはChat
          API(GPT-3.5)のポリシーに反する内容だったため、AIからの回答を受け取れませんでした。<br />お手数ですが、画面右「タイトル案」をご検討ください。
        </p>
        <div v-else class="c-text--free">
          <p>以下は、理想的なタイトル案の例です。</p>
          <ol class="c-list--decimal">
            <li v-for="item in aiTitleData.items" :key="item">
              {{ item }}
            </li>
          </ol>
        </div>
      </Advice>
      <div v-if="isError" class="p-contentplans-writing-ai-phase__buttons">
        <div class="c-alertPos">
          <ButtonRectangle
            priority="high"
            :isLoading="isProcessing"
            :disabled="isDisabledInputButton"
            @click="submitInput"
            >記入して構成案を編集</ButtonRectangle
          >
          <Alert v-if="error">{{ error }}</Alert>
        </div>
      </div>
      <div v-else class="p-contentplans-writing-ai-fieldset">
        <p class="p-contentplans-writing-ai-fieldset__title">
          タイトル案のベースにしたいものを選択してください。
        </p>
        <div class="p-contentplans-writing-ai-fieldset__content">
          <Select
            :options="selectOptions"
            :selected="selected"
            placement="top"
            :readOnly="isReadOnlySelect"
            required
            @change="change"
          />
          <div class="c-alertPos">
            <ButtonRectangle
              priority="high"
              :isLoading="isProcessing"
              :disabled="isDisabledSelectButton"
              @click="submitSelect"
              >選択して構成案を編集</ButtonRectangle
            >
            <Alert v-if="error">{{ error }}</Alert>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Advice from '@/components/Advice';
import Alert from '@/components/Alert';
import ButtonRectangle from '@/components/ButtonRectangle';
import Select from '@/components/Select';

export default {
  props: {
    aiTitleData: {
      type: Object,
      required: false,
      default: null
    },
    error: {
      type: String,
      required: true
    },
    userSelectedTitle: {
      type: String,
      required: true
    },
    userTitle: {
      type: String,
      required: true
    },
    isCurrent: {
      type: Boolean,
      required: true
    },
    isDisabled: {
      type: Boolean,
      required: true
    },
    isEditMode: {
      type: Boolean,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isProcessing: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Advice,
    Alert,
    ButtonRectangle,
    Select
  },
  data() {
    return {
      selected: this.userSelectedTitle
    };
  },
  computed: {
    selectOptions() {
      if (
        !this.aiTitleData ||
        !this.aiTitleData.items ||
        !this.aiTitleData.items.length
      ) {
        return [];
      }
      return this.aiTitleData.items.map(item => {
        return { label: item, value: item };
      });
    },
    isDisabledInputButton() {
      // 別のフェーズ、送信中、未入力の場合はtrue
      return !this.isEditMode ||
        this.isDisabled ||
        !this.isCurrent ||
        this.isProcessing ||
        !this.userTitle
        ? true
        : false;
    },
    isDisabledSelectButton() {
      // 別のフェーズ、送信中、未選択の場合はtrue
      return !this.isEditMode ||
        this.isDisabled ||
        !this.isCurrent ||
        this.isProcessing ||
        !this.selected
        ? true
        : false;
    },
    isError() {
      // dataがnull、またはitemsが空の場合はtrue
      return !this.aiTitleData ||
        !this.aiTitleData.items ||
        !this.aiTitleData.items.length
        ? true
        : false;
    },
    isReadOnlySelect() {
      // 別のフェーズの場合はtrue
      return !this.isEditMode || !this.isCurrent ? true : false;
    }
  },
  methods: {
    change(selected) {
      if (this.isReadOnlySelect) {
        return;
      }
      this.selected = selected;
    },
    submit(selected) {
      this.$emit('submit', selected);
    },
    submitInput() {
      if (this.isDisabledInputButton) {
        return;
      }
      this.submit();
    },
    submitSelect() {
      if (this.isDisabledSelectButton) {
        return;
      }
      this.submit(this.selected);
    }
  }
};
</script>
